var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "label-workspace",
    on: {
      "mousedown": function mousedown($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('select', null);
      }
    }
  }, [_c('div', {
    staticClass: "workspace-toolbar"
  }, [_vm._m(0), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "text-muted mr-3"
  }, [_vm._v("Grade de 0,5 mm · Área segura " + _vm._s(_vm.safePadding) + " mm · Margens da folha " + _vm._s(_vm.pageMarginSummary))]), _c('span', {
    staticClass: "badge badge-light"
  }, [_vm._v(_vm._s(_vm.labelWidth) + " × " + _vm._s(_vm.labelHeight) + " mm")])])]), _c('div', {
    staticClass: "canvas-scroll",
    on: {
      "mousedown": function mousedown($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('select', null);
      }
    }
  }, [_c('div', {
    staticClass: "canvas-stage",
    style: _vm.stageStyle,
    on: {
      "mousedown": function mousedown($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('select', null);
      }
    }
  }, [_c('div', {
    staticClass: "ruler ruler-x",
    style: _vm.rulerXStyle
  }, _vm._l(_vm.xMarks, function (mark) {
    return _c('span', {
      key: "x-".concat(mark),
      style: {
        left: "".concat(mark * _vm.scale, "px")
      }
    }, [_vm._v(_vm._s(mark))]);
  }), 0), _c('div', {
    staticClass: "ruler ruler-y",
    style: _vm.rulerYStyle
  }, _vm._l(_vm.yMarks, function (mark) {
    return _c('span', {
      key: "y-".concat(mark),
      style: {
        top: "".concat(mark * _vm.scale, "px")
      }
    }, [_vm._v(_vm._s(mark))]);
  }), 0), _vm._l(_vm.pageMarginBands, function (band) {
    return _c('div', {
      key: band.side,
      class: ['page-margin-band', "margin-".concat(band.side)],
      style: band.style,
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('span', [_vm._v("Margem da folha · " + _vm._s(_vm.formatMillimeters(band.size)) + " mm")])]);
  }), _c('div', {
    ref: "label",
    staticClass: "label-canvas",
    class: {
      'has-grid': _vm.showGrid
    },
    style: _vm.canvasStyle,
    on: {
      "mousedown": function mousedown($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('select', null);
      }
    }
  }, [_vm.safePadding > 0 ? _c('div', {
    staticClass: "safe-area-shade",
    style: _vm.safeAreaStyle,
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "safe-area",
    style: _vm.safeAreaStyle
  }), _vm._l(_vm.renderedElements, function (element) {
    return _c('div', {
      key: element.id,
      staticClass: "label-element",
      class: _vm.elementClasses(element),
      style: _vm.elementStyle(element),
      attrs: {
        "role": "button",
        "aria-label": "Selecionar ".concat(_vm.sourceElement(element).nome),
        "tabindex": element.visivel === false ? -1 : 0
      },
      on: {
        "mousedown": function mousedown($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.beginDrag($event, element);
        },
        "click": function click($event) {
          $event.stopPropagation();
          _vm.$emit('select', _vm.sourceElementId(element));
        },
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          $event.stopPropagation();
          _vm.$emit('select', _vm.sourceElementId(element));
        }
      }
    }, [_vm.elementContentVisible(element) ? [_vm.previewElementType(element) === 'barcode' ? [_vm.codeAssetUrl(element) ? _c('div', {
      staticClass: "code-preview"
    }, [_c('img', {
      staticClass: "code-image",
      style: _vm.barcodeImageStyle(element),
      attrs: {
        "alt": "Código de barras",
        "src": _vm.codeAssetUrl(element)
      }
    }), element.codigo_barras && element.codigo_barras.exibir_texto ? _c('small', [_vm._v(" " + _vm._s(_vm.rawValue(element)) + " ")]) : _vm._e()]) : _vm.codeAssetFailed(element) ? _c('span', {
      staticClass: "code-preview-error"
    }, [_vm._v("Prévia indisponível")]) : _vm._e()] : _vm.previewElementType(element) === 'qrcode' ? [_vm.codeAssetUrl(element) ? _c('img', {
      staticClass: "qr-preview",
      attrs: {
        "alt": "QR Code",
        "src": _vm.codeAssetUrl(element)
      }
    }) : _vm.codeAssetFailed(element) ? _c('span', {
      staticClass: "code-preview-error"
    }, [_vm._v("Prévia indisponível")]) : _vm._e()] : _vm.previewElementType(element) === 'logo' ? [_vm.logoUrl ? _c('img', {
      staticClass: "logo-preview",
      attrs: {
        "alt": "Logo da empresa",
        "src": _vm.logoUrl
      }
    }) : _vm._e()] : _vm.previewElementType(element) === 'line' ? [_c('span', {
      staticClass: "line-preview",
      style: _vm.linePreviewStyle(element)
    })] : _vm.previewElementType(element) === 'rectangle' ? void 0 : [_vm.priceLines(element) ? _c('span', {
      staticClass: "element-text"
    }, _vm._l(_vm.priceLines(element), function (line, index) {
      return _c('span', {
        key: index,
        staticClass: "element-text-line",
        style: _vm.priceLineStyle(element, line)
      }, [_vm._v(_vm._s(line))]);
    }), 0) : _c('span', {
      staticClass: "element-text"
    }, [_vm._v(_vm._s(_vm.displayValue(element)))])]] : _vm._e(), element.visivel === false ? _c('span', {
      staticClass: "hidden-label"
    }, [_vm._v("Oculto")]) : _vm.selectedId === _vm.sourceElementId(element) && !_vm.elementContentVisible(element) ? _c('span', {
      staticClass: "hidden-label"
    }, [_vm._v("Não será impresso")]) : _vm._e(), _vm.selectedId === _vm.sourceElementId(element) ? [_vm.isFirstRenderedPart(element) ? _c('span', {
      staticClass: "selection-name"
    }, [_vm._v(_vm._s(_vm.sourceElement(element).nome))]) : _vm._e(), _vm.isLastRenderedPart(element) ? _c('span', {
      staticClass: "resize-handle",
      attrs: {
        "title": "Redimensionar"
      },
      on: {
        "mousedown": function mousedown($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.beginResize($event, element);
        }
      }
    }) : _vm._e()] : _vm._e()], 2);
  })], 2)], 2)]), _vm._m(1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "live-dot"
  }), _c('strong', [_vm._v("Área de edição instantânea")]), _c('span', {
    staticClass: "text-muted ml-2"
  }, [_vm._v("Dados de exemplo")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "workspace-help"
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-mouse-pointer"
  }), _vm._v(" Arraste para mover")]), _c('span', [_c('i', {
    staticClass: "fas fa-expand-alt"
  }), _vm._v(" Puxe o canto para redimensionar")]), _c('span', [_c('kbd', [_vm._v("Del")]), _vm._v(" remove")]), _c('span', [_c('kbd', [_vm._v("Ctrl")]), _vm._v(" + "), _c('kbd', [_vm._v("Z")]), _vm._v(" desfaz")])]);
}];
export { render, staticRenderFns };